<template lang="html">
  <div class="flex flex-col">
    <TgBanner />

    <CatalogSection class="w-full max-w-480 sm:m-auto" />

    <div class="main-catalog-container w-full sm:m-auto sm:max-w-480">
      <CatalogContent
        class="w-full pt-16 sm:m-auto"
        :selected-category="undefined"
        @update:selected-category="onCategorySelect"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import CatalogContent from '#Products/components/Catalog/CatalogContent.vue'
import CatalogSection from '#Products/components/Info/CatalogSection.vue'
import type { CategoryDto } from '#Products/models/Pim/CategoryDto'
import TgBanner from '~/app/components/Banner/TgBanner.vue'

definePageMeta({
  name: 'ProductsIndex',
  layoutContainer: 'full',
})

const route = useRoute()
const { routing } = useProducts()
const { all } = await useCategories()

// Легаси числовой URL категории (/:id) → 301 на ЧПУ /catalog/:slug;
// неизвестный корневой путь — 404 (не soft-404 в каталог)
const legacyCategoryId = computed(() => route.params.category as string | undefined)
if (legacyCategoryId.value) {
  const category = all.value?.[legacyCategoryId.value] as CategoryDto | undefined
  if (!category) {
    throw createError({ statusCode: 404, statusMessage: 'Page not found' })
  }
  await navigateTo(routing.getCatalog(category).route, {
    redirectCode: 301,
    replace: true,
  })
}

// Главная — каталог без выбранной категории
useCategorySeo(computed(() => undefined), all)

function onCategorySelect(category?: CategoryDto) {
  navigateTo(category ? routing.getCatalog(category).route : '/')
}
</script>

<style lang="css" scoped>
.main-catalog-container {
  background:
    url('/catalog/brand/patternLeft.svg') top left / 40% repeat-y,
    url('/catalog/brand/patternRight.svg') top right / 40% repeat-y;
}
</style>
